<template>
  <Layout>
    <v-row justify="center" class="my-2">
      <h3>รายการนับสินค้าตามสาขา</h3>
    </v-row>
    <template v-if="loading">
      <v-skeleton-loader
        v-bind="attrs"
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <v-row justify="start">
        <v-col class="d-flex justify-start">
          <h3 v-if="storeName">ชื่อสาขา: {{ storeName }}</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn elevation="2" @click="goBack">ย้อนกลับ</v-btn>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn elevation="2" @click="goActivity" class="mr-2">
            ประวัติการบันทึกข้อมูล
          </v-btn>
          <v-menu
            :close-on-content-click="closeOnContentClick"
            left
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                ดาวน์โหลดรายงาน
              </v-btn>
            </template>

            <v-list>
              <template v-for="(item, index) in items">
                <v-list-item
                  v-if="item.enabled"
                  :key="index"
                  :class="item.className"
                  @click="report(item.report)"
                >
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row align="center">
        <template v-if="storeDetailTab === 0">
          <v-col cols="4">
            <v-text-field
              v-model="searchText"
              label="ค้นหา โปรดักโค้ด ชื่อสินค้า"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              :items="selectStatusItems"
              label="สถานะ"
              v-model="statusFilter"
              item-text="name"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-btn elevation="2" @click="clear"> ล้างข้อมูล </v-btn>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="4">
            <v-text-field
              v-model="searchTextOver"
              label="ค้นหา โปรดักโค้ด ชื่อสินค้า"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn elevation="2" @click="clearStockOver">
              ล้างข้อมูล
            </v-btn>
          </v-col>
        </template>
      </v-row>
      <v-row>
        <v-col>
          <TableStoreDetail :data="storeDetail" />
        </v-col>
      </v-row>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import TableStoreDetail from '@/components/TableStoreDetail'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      storeDetail: (state) => state.job.storeDetail,
      storeDetailLoading: (state) => state.job.isLoading,
      storeDetailTab: (state) => state.job.storeDetailTab,
    }),
    searchText: {
      get() {
        return this.$store.state?.job?.searchStoreDetail
      },
      set(value) {
        this.$store.commit('job/SET_SEARCH_STORE_DETAIL', value)
      },
    },
    searchTextOver: {
      get() {
        return this.$store.state?.job?.searchStoreDetailOver
      },
      set(value) {
        this.$store.commit('job/SET_SEARCH_STORE_DETAIL_OVER', value)
      },
    },
    statusFilter: {
      get() {
        return this.$store.state?.job?.statusStoreDetail
      },
      set(value) {
        this.$store.commit('job/SET_STATUS_STORE_DETAIL', value)
      },
    },
    storeName() {
      return this.storeDetail?.store_name
    },
    loading() {
      return this.storeDetailLoading
    },
    items() {
      return [
        {
          title: 'รายงานความคืบหน้าของสาขา',
          report: 'stockProgress',
          className: 'bg-yellow-light',
          enabled: true,
        },
        {
          title: 'รายงานพนักงานที่ไม่นับสต็อค',
          report: 'employeesNotCheckedStock',
          className: 'bg-yellow-light',
          enabled: true,
        },
        {
          title: 'รายงานการตรวจนับสต็อคของสาขา',
          report: 'stockChecked',
          enabled: this.storeDetail?.cal_at,
        },
        {
          title: 'ประวัติการบันทึกข้อมูลของสาขา',
          report: 'activityLog',
          enabled: true,
        },
      ]
    },
  },

  components: {
    TableStoreDetail,
    Layout,
  },

  data() {
    return {
      selectStatusItems: [
        {
          name: 'ทั้งหมด',
          value: null,
        },
        {
          name: 'ปกติ',
          value: 1,
        },
        {
          name: 'สต็อกไม่ถูกต้อง',
          value: 2,
        },
        {
          name: 'สต็อกเกินจากระบบ',
          value: 3,
        },
        {
          name: 'ยังไม่ได้รับการตรวจ',
          value: 4,
        },
      ],
      closeOnContentClick: true,
    }
  },

  async mounted() {
    const payload = {
      id: this.$route.params.id,
      storeId: this.$route.params.storeId,
    }
    await this.$store.dispatch('job/getStoreDetail', payload)
  },

  methods: {
    createJob() {
      this.$router.push({
        name: 'CreateJob',
      })
    },
    goBack() {
      this.$store.commit('job/RESET_STORE_DETAIL')
      this.$store.commit('job/RESET_STORE_DETAIL_OVER')
      this.$router.push({
        name: 'JobDetail',
        params: {
          id: this.$route.params.id,
        },
      })
    },
    goActivity() {
      this.$router.push({
        name: 'AllActivity',
        params: {
          id: this.$route.params.id,
          storeId: this.$route.params.storeId,
        },
      })
    },
    async report(val) {
      const payload = {
        job_id: this.$route.params.id,
        store_id: this.$route.params.storeId,
        filter_status: this.statusFilter,
        name: `job_id_${this.$route.params.id}_store_id_${this.$route.params.storeId}`,
      }
      await this.$store.dispatch(`report/${val}`, payload)
    },
    clear() {
      this.$store.commit('job/RESET_STORE_DETAIL')
    },
    clearStockOver() {
      this.$store.commit('job/RESET_STORE_DETAIL_OVER')
    },
  },
}
</script>

<style scoped>
/deep/ .v-list-item__title {
  text-align: left;
  line-height: 1.5;
}
</style>
